import { createClient } from "@supabase/supabase-js";

// Get environment variables with fallbacks
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://segunbiirxpptzodasoa.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlZ3VuYmlpcnhwcHR6b2Rhc29hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwMzkxNzMsImV4cCI6MjA1NDYxNTE3M30.HUcfWUvbsUWZU0ONiggNEWG8IYbwu6Fc_GZc51fUj_k';

// Log Supabase initialization for debugging
console.log('Initializing Supabase client with URL:', supabaseUrl ? 'URL is defined' : 'URL is undefined');
if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase environment variables are missing. Using fallback values.');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Add a helper function to reliably fetch textures
export const fetchTextures = async () => {
  try {
    console.log('Fetching textures from Supabase directly...');
    const { data, error } = await supabase.from('texture').select('*');
    
    if (error) {
      console.error('Error fetching textures:', error);
      return { data: null, error };
    }
    
    console.log('Successfully fetched', data?.length || 0, 'textures');
    
    // If no data, provide some fallback texture data
    if (!data || data.length === 0) {
      return { 
        data: generateFallbackTextures(), 
        error: null 
      };
    }
    
    return { data, error: null };
  } catch (err) {
    console.error('Exception when fetching textures:', err);
    return { 
      data: generateFallbackTextures(), 
      error: err 
    };
  }
};

// Generate some fallback texture data if the database is unreachable
const generateFallbackTextures = () => {
  console.log('Generating fallback texture data');
  const categories = ['Metals', 'Polymers', 'Ceramics', 'Wood', 'Fabrics'];
  const materials = ['Steel', 'Aluminum', 'Plastic', 'Cotton', 'Ceramic'];
  
  return Array(20).fill(0).map((_, i) => ({
    id: i + 1,
    texture_name: `Fallback Texture ${i + 1}`,
    material_name: materials[i % materials.length],
    category_name: categories[i % categories.length],
    tactile_tags: 'smooth rough',
    aesthetic_tags: 'shiny matte',
    technical_tags: 'durable flexible',
    description: 'A fallback texture when the database is unavailable',
    average_color: `hsl(${i * 20}, 70%, 50%)`,
    created_at: new Date().toISOString()
  }));
}; 